export const content = {
  title:'Agregar distribuidor',
  nodata:'Sin Registro',
  error:'Sin registro',
  button:'Agregar',
  cancelButton:'Cancelar',
  image_button:'Cambiar',
  form:{
    provider_id:{
      label:'Distribuidor',
      placeholder:'Seleccione un distribuidor',
    },
  },
}